import React from 'react';
import { BrainIcon } from 'lucide-react';
type TeamTabsProps = {
  activeTab: string;
  setActiveTab: (tab: string) => void;
};
const TeamTabs = ({
  activeTab,
  setActiveTab
}: TeamTabsProps) => {
  const tabs = [{
    id: 'overview',
    label: 'OVERVIEW'
  }, {
    id: 'neuro',
    label: 'NEURO',
    icon: BrainIcon
  }, {
    id: 'lineups',
    label: 'LINEUPS'
  }, {
    id: 'onOff',
    label: 'ON/OFF'
  }, {
    id: 'boxscore',
    label: 'BOXSCORE'
  }, {
    id: 'charts',
    label: 'CHARTS'
  }, {
    id: 'comboDuos',
    label: 'COMBO DUOS'
  }, {
    id: 'roster',
    label: 'ROSTER'
  }, {
    id: 'calendar',
    label: 'CALENDAR'
  }, {
    id: 'highs',
    label: 'HIGHS'
  }, {
    id: 'news',
    label: 'NEWS'
  }, {
    id: 'club',
    label: 'CLUB'
  }];
  return <div className="border-b" data-id="element-940" data-mp="1dqgxpve7cq7h">
      <div className="flex" data-id="element-941" data-mp="1dr9ty2fjbxbd">
        {tabs.map(tab => <button key={tab.id} onClick={() => setActiveTab(tab.id)} className={`px-4 py-2 text-sm font-medium flex items-center gap-1.5 ${activeTab === tab.id ? 'border-b-2 border-blue-600 text-blue-600' : 'text-gray-600 hover:text-gray-800'}`} data-id="element-942" data-mp="1ip1n0zrx1ph5">
            {tab.icon && <tab.icon className="w-4 h-4" data-id="element-943" data-mp="2bchsw174m815" />}
            {tab.label}
          </button>)}
      </div>
    </div>;
};
export default TeamTabs;